import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, withStyles } from '@mui/styles';
import CloseButton from '@/components/UI/CloseButton/CloseButton';
import stylesImg from './Image.module.scss';

const DialogOpenImage = ({ close, title, image, closeBtnText = 'Close', fullWidth, maxWidth }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const styles = (them) => ({
    root: {
      margin: 0,
      padding: them.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: them.spacing(1),
      top: them.spacing(1),
      color: them.palette.grey[500],
    },
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children: childrenTitle, classes, onClose, ...other } = props;

    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{childrenTitle}</Typography>
        {onClose
          ? (
            <CloseButton onClick={onClose} closeStyle={classes.closeButton} />
          )
          : null}
      </MuiDialogTitle>
    );
  });

  return (
    <Dialog
      id="generic-confirm-dialog"
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      open
      fullScreen={fullScreen}
      onClose={close}
      aria-labelledby="responsive-dialog-title"
    >
      { title && <DialogTitle id="responsive-dialog-title">{title} </DialogTitle>}
      <DialogContent>
        <img
          className={stylesImg.ImgOpenImage}
          id="open-image"
          src={image}
          alt={title}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={close} color="primary">{closeBtnText}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogOpenImage;
